<template v-if="getSystemNotificationMessage()">
  <div v-bind:class="{'sanitas-system-notification': getSystemNotificationMessage()}">
    {{ getSystemNotificationMessage() }}
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  components: {},
  name: 'SystemNotification',
  computed: {
    ...mapGetters('uistate', ['getSanitasSystemNotifications'])
  },
  methods: {
    getSystemNotificationMessage () {
      let message = null
      if (this.getSanitasSystemNotifications.length > 0) {
        if (this.getSanitasSystemNotifications[0].conditions[0].value.includes(window._sanChatConfig.channel)) {
          message = this.getSanitasSystemNotifications[0].text
        }
      }
      return message
    }
  }
}
</script>

<style scoped lang="postcss">
.sanitas-system-notification {
  background-color: #ffe539;
  color: #191919;
  font-size: 15px;
  padding: 15px;
}
</style>